import * as React from 'react';

import Form from './Form';
import HistoryRowData from './HistoryRowData';

import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import HistoryRow from 'Components/HistoryRow';
import FormEditingHandler from 'Containers/FormEditingHandler';
import HistoryRowControls from 'Components/HistoryRowControls';

import { sortPartialDate } from 'neuro-utils';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { formatPartialDate } from 'Utility/date';

const DEFAULT_DOCUMENTS: IOwnProps['documents'] = [];

const GeneralHealth = ({ documents = DEFAULT_DOCUMENTS }: IOwnProps): React.JSX.Element => {
  return (
    <FormEditingHandler name="generalhealth" documents={documents}>
      {(editing, startEdit, formData): React.JSX.Element => (
        <DocumentWrapper>
          <DocumentHeader
            name="generalhealth"
            headerId={'generalhealth.title'}
            editing={editing}
            editButtons={
              <div>
                <DocumentCreationButton
                  name="generalhealth"
                  text={'generalhealth.newGeneralHealth'}
                  onClick={startEdit({})}
                />
              </div>
            }
          />
          {!editing && documents
            ? documents
                .toSorted((n1, n2) => sortPartialDate(n2.date, n1.date))
                .map(d => (
                  <HistoryRow
                    headerText={d.date ? formatPartialDate(d.date) : undefined}
                    key={d._id}
                    rowButton={<HistoryRowControls document={d} startEdit={startEdit} />}
                    controlsMargin={false}
                  >
                    <HistoryRowData d={d} />
                  </HistoryRow>
                ))
            : undefined}
          {editing ? <Form formData={formData} editing={editing} /> : undefined}
        </DocumentWrapper>
      )}
    </FormEditingHandler>
  );
};

interface IOwnProps {
  documents?: IDocumentWithTypeV2<'generalhealth'>[];
}

export default GeneralHealth;
